"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["id"];
const _hoisted_2 = { style: { "border-bottom": "1px solid #d9d0c7" } };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { class: "destination_code" };
const _hoisted_5 = { class: "destination_code_n" };
const _hoisted_6 = { key: 1 };
const _hoisted_7 = { class: "destination_name" };
const _hoisted_8 = { key: 2 };
const _hoisted_9 = { class: "destination_type" };
const _hoisted_10 = { style: { "border-bottom": "1px solid #d9d0c7" } };
const _hoisted_11 = { key: 0 };
const _hoisted_12 = { class: "zipcode" };
const _hoisted_13 = { key: 1 };
const _hoisted_14 = { class: "address" };
const _hoisted_15 = { key: 1 };
const _hoisted_16 = { class: "updated_at" };
const moment_1 = __importDefault(require("moment"));
const vue_3 = require("vue");
const BssMapLatLng_vue_1 = __importDefault(require("./BssMapLatLng.vue"));
const category_key = 'd_infobox_settings';
exports.default = (0, vue_1.defineComponent)({
    __name: 'BssMapDestinationInfobox',
    props: {
        data: {},
        movementSettings: {}
    },
    setup(__props) {
        const props = __props;
        const messages = (0, vue_3.inject)('messages');
        const id = props.data.id;
        const infobox_messages = messages.d_infobox;
        const checkMovementSetting = window.checkMovementSetting;
        const updated_at = (0, vue_3.computed)(() => (0, moment_1.default)(props.data.updated_at).format('YYYY/MM/DD HH:mm:ss'));
        const is_visible_item1 = (0, vue_3.computed)(() => checkMovementSetting(null, category_key, 'destination_code', props.movementSettings)); // 1.地点コード
        const is_visible_item2 = (0, vue_3.computed)(() => checkMovementSetting(null, category_key, 'destination_name', props.movementSettings)); // 2.地点名
        const is_visible_item3 = (0, vue_3.computed)(() => checkMovementSetting(null, category_key, 'destination_type', props.movementSettings)); // 3.地点区分
        const is_visible_item4 = (0, vue_3.computed)(() => checkMovementSetting(null, category_key, 'address', props.movementSettings)); // 4.住所
        const is_visible_item5 = (0, vue_3.computed)(() => checkMovementSetting(null, category_key, 'latlon', props.movementSettings)); // 5.緯度・経度
        const is_visible_item6 = (0, vue_3.computed)(() => checkMovementSetting(null, category_key, 'updated_at', props.movementSettings)); // 6.最終更新日時
        function getDestinationTypeMessage(destination_type, messages) {
            const _destination_type = (destination_type || '').toString();
            let message = _destination_type;
            if (messages.destination_types.hasOwnProperty(_destination_type)) {
                message = messages.destination_types[_destination_type];
            }
            return message;
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                id: `infobox_destination_${(0, vue_2.unref)(id)}`,
                style: { "color": "#89684f" }
            }, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (is_visible_item1.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_3, [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).destination_code) + ": ", 1),
                            (0, vue_2.createElementVNode)("span", _hoisted_4, (0, vue_2.toDisplayString)(_ctx.data.code || ''), 1),
                            _cache[0] || (_cache[0] = (0, vue_2.createTextVNode)(" (", -1)),
                            (0, vue_2.createElementVNode)("span", _hoisted_5, (0, vue_2.toDisplayString)((_ctx.data.code || '') != '' ? parseInt(_ctx.data.code) : ' '), 1),
                            _cache[1] || (_cache[1] = (0, vue_2.createTextVNode)(") ", -1))
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (is_visible_item2.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_6, [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).destination_name) + ": ", 1),
                            (0, vue_2.createElementVNode)("span", _hoisted_7, (0, vue_2.toDisplayString)(_ctx.data.name || ''), 1)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (is_visible_item3.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_8, [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).destination_type) + ": ", 1),
                            (0, vue_2.createElementVNode)("span", _hoisted_9, (0, vue_2.toDisplayString)(getDestinationTypeMessage(_ctx.data.destination_type, (0, vue_2.unref)(messages))), 1)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true)
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_10, [
                    (is_visible_item4.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_11, [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).zipcode) + ": ", 1),
                            (0, vue_2.createElementVNode)("span", _hoisted_12, (0, vue_2.toDisplayString)(_ctx.data.zipcode || ''), 1)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (is_visible_item4.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_13, [
                            (0, vue_2.createElementVNode)("span", _hoisted_14, (0, vue_2.toDisplayString)((_ctx.data.prefecture || '') + (_ctx.data.municipality || '') + (_ctx.data.address || '')), 1)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true)
                ]),
                (0, vue_2.createElementVNode)("div", null, [
                    (is_visible_item5.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(BssMapLatLng_vue_1.default, {
                            key: 0,
                            latitude: _ctx.data.latitude,
                            longitude: _ctx.data.longitude
                        }, null, 8, ["latitude", "longitude"]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (is_visible_item6.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_15, [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).updated_at) + ": ", 1),
                            (0, vue_2.createElementVNode)("span", _hoisted_16, (0, vue_2.toDisplayString)(updated_at.value), 1)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true)
                ])
            ], 8, _hoisted_1));
        };
    }
});
